var url = location.href;

if(url == "https://kronotime.com/cart"){
  if(sessionStorage.getItem("popup-iva") != "yes" && document.getElementById("product-iva")){
  	$("#modalIva").css("display", "flex");
  }
}

$("#modalIva").click(function() {
    $("#modalIva").css("display", "none");
   sessionStorage.setItem("popup-iva", "yes");
});

$("#btn-iva-modal").click(function(){
	$("#modalIva").css("display", "none");
   sessionStorage.setItem("popup-iva", "yes");
});

$("#btn-iva").click(function(){
	$("#modalIva").css("display", "none");
   sessionStorage.setItem("popup-iva", "yes");
});

$('.modal-dialog').click(function(event){
    event.stopPropagation();
});

$("#cart-pop-iva").click(function(){
	$("#modalIva").css("display", "flex");
});

var urlThankYou = location.href;
console.log(localStorage.getItem("_dsi"))
if(urlThankYou.includes("cart") &&  localStorage.getItem("_dsi") != null && $("#count-dsi").val() > 0){
	$("#modalSuccessDSI").css("display", "flex");
  	$("#modalIva").css("display", "none");
}

$("#btn-dsi-success-modal").click(function(){
	$("#modalSuccessDSI").css("display", "none");
})

$("html").click(function() {
	$("#modalSuccessDSI").css("display", "none");
})

if($("#diaSinIVA").val() == "true"){
  	if(parseInt($("#ComparePrice").text().replace(/[$.]/gm, "")) > 726160){
      	$(".shopify-payment-button__button").prop("disabled", true)
        $(".btn-swk-add-cart").prop("disabled", true)
      	$("#modalIva").css("display", "flex");
    }else{
      	$(".shopify-payment-button__button").prop("disabled", false)
        $(".btn-malva-add-cart").prop("disabled", false)
    }	
	$("#Quantity").change(function(e){
      if(e.target.value > 3){
        $("#modalIva").css("display", "flex");
        e.target.value = 3
      }
    })
}

$("#modalIvaMantenimiento").css("display", "flex");

//COUNTDOWN
    
 /*     var countDownDate = new Date("DEC 4, 2021 00:00:00 GMT-0500").getTime();


      var x = setInterval(function() {


        var now = new Date().getTime();


        var distance = countDownDate - now;

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);


        document.getElementById("countdown").innerHTML = + hours + ":"
        + minutes + ":" + seconds + "";

        // If the count down is over, write some text 
        if (distance < 0) {
          clearInterval(x);
          document.getElementById("countdown").innerHTML = "EXPIRED";
        }
      }, 1000);*/